/**
 * <product-form> — AJAX add-to-cart (brief section 17): click → loading →
 * added → cart updated → drawer opens, no full page reload. Also owns the
 * beneficiary-fields (certification products) toggle + validation, since
 * both live inside the same <form> now (see main-product.liquid).
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[data-add-to-cart]');
    this.errorEl = this.querySelector('[data-add-to-cart-error]');
    this.statusEl = this.querySelector('[data-add-to-cart-status]');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.querySelectorAll('[data-beneficiary-mode]').forEach((radio) =>
      radio.addEventListener('change', this.onBeneficiaryModeChange.bind(this))
    );
  }

  onBeneficiaryModeChange(event) {
    const details = this.querySelector('[data-beneficiary-details]');
    if (!details) return;
    const showDetails = event.target.dataset.beneficiaryMode === 'someone_else';
    details.hidden = !showDetails;
    const nameInput = this.querySelector('[data-beneficiary-name]');
    const emailInput = this.querySelector('[data-beneficiary-email]');
    if (nameInput) nameInput.required = showDetails;
    if (emailInput) emailInput.required = showDetails;
  }

  validateBeneficiary() {
    const details = this.querySelector('[data-beneficiary-details]');
    if (!details || details.hidden) return true;
    const name = this.querySelector('[data-beneficiary-name]');
    const email = this.querySelector('[data-beneficiary-email]');
    if (!name.value.trim() || !email.value.trim()) {
      this.showError(window.NantesStrings.cartError || 'error');
      return false;
    }
    return true;
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.validateBeneficiary()) return;

    this.setLoading(true);
    this.hideError();

    const formData = new FormData(this.form);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const result = await response.json();

      if (!response.ok) {
        this.showError(result.description || result.message || window.NantesStrings.cartError);
        this.setLoading(false);
        return;
      }

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      cart.justAdded = true;

      await window.NantesCart.refreshCartSections(cart);
      this.statusEl.textContent = window.NantesStrings.cartItemAdded;
    } catch (error) {
      this.showError(window.NantesStrings.cartError);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    const text = this.submitButton.querySelector('[data-add-to-cart-text]');
    const spinner = this.submitButton.querySelector('[data-add-to-cart-spinner]');
    this.submitButton.disabled = isLoading;
    if (spinner) spinner.hidden = !isLoading;
    if (text) text.hidden = isLoading;
  }

  showError(message) {
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }

  hideError() {
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  }
}

customElements.define('product-form', ProductForm);
